export default function(){


	(function($) {

		// Single product mobile swiper
		var single_product_swiper;
		var prevWidth = 0; // 0 for first init

		function init_single_product_swiper(){

			var currentWidth = window.screen.width

			// Width change only
			if (currentWidth == prevWidth ) {
				return
			}
			prevWidth = currentWidth

			if(single_product_swiper){
				single_product_swiper.destroy()
			}

			// Single product gallery Swiper
			if(currentWidth < 768){
				single_product_swiper = new Swiper('.single-product-gallery', {
					speed: 300,
					loop: true,
					pagination: {
						el: '.swiper-pagination',
						type: 'bullets',
					},
					navigation: {
						nextEl: ".swiper-arrow-next",
						prevEl: ".swiper-arrow-prev",
					},
				});
			}
		}

		$(window).on('load resize', init_single_product_swiper);

	})(jQuery);
}